<template>
  <div id="footerContainer"> <!--root-->
    <div>
      <a href="/">Home</a>
      <a href="#">Kontakt</a>
      <a target="_blank" href="https://www.ad-alliance.de/cms/lp/datenschutz_.html">Datenschutz</a>
      <a target="_blank" href="https://www.ad-alliance.de/cms/datenschutz/impressum.html">Impressum</a>
      <a href="#">AGB</a>
    </div>
    <div id="copyright">
      &copy; Ad Alliance GmbH
      &bull; Überseeallee 10
      &bull; 20457 Hamburg
      &bull; Postanschrift:20444 Hamburg
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style scoped lang="scss">
@use "@/assets/styles/variables.scss" as *;

#footerContainer {
  height: $footerHeight;
  bottom: 0;
  width: 100%;
  background-color: $footerBackground;
  padding: 40px 10vw;
  box-sizing: border-box;
  color: white;
}

#footerContainer a {
  color: white;
  text-decoration: none;
}

#footerContainer a:after {
  content: '|';
  padding: 0 40px;
}

#footerContainer a:last-child:after {
  content: '';
}

#copyright {
  padding: 15px 0;
  font-size: smaller;
  color: white;
}
</style>